module.exports = "/assets/fa07a27867fc79f0955b24fbdec56674.png";